<div class="qr-code-container" [ngClass]="{'modal-view': isModal}">
  @if (!showQRCode) {
    <div class="qr-code-buttons">
      @if (hasJWT && !jwtExpired && type !== 'router') {
        <div (click)="identitiesSvc.downloadJWT(jwt, identity.name)" class="download-button">
          <div class="download-jwt"></div>
          <div>DOWNLOAD JWT</div>
          <div class="tap-to-download icon-download-jwt"></div>
        </div>
      }
      @if (hasJWT && !jwtExpired && type !== 'router') {
        <div (click)="expandQRCode()" class="download-button" matTooltip="Show QR Code">
          <div class="tap-to-download icon-qr"></div>
          <div>SHOW QR CODE</div>
          <div class="tap-to-download icon-ClickIcon"></div>
        </div>
      }
      @if (!jwtExpired && type === 'router') {
        <div (click)="identitiesSvc.copyToken(token)" class="download-button" style="background-color: #232f3e!important;">
          <div class="download-key"></div>
          <div>COPY ENROLLMENT TOKEN</div>
          <div class="tap-to-download icon-ClickIcon"></div>
        </div>
      }
      @if (showResetToken) {
        <div (click)="identitiesSvc.resetJWT(identity)" class="download-button" >
          <div class="download-key"></div>
          <div>RESET ENROLLMENT</div>
          <div class="tap-to-download icon-refresh"></div>
        </div>
      }
      @if (showReissueToken) {
        <div (click)="reissue()" class="download-button" >
          <div class="download-key"></div>
          <div>REISSUE ENROLLMENT</div>
          <div class="tap-to-download icon-refresh"></div>
        </div>
      }
      @if (showResetMFA || mfaReset) {
        <div (click)="resetMFA()" class="download-button" [ngClass]="{'reset-success': mfaReset}">
          <div class="icon-lock"></div>
          <div>{{mfaReset ? 'MFA RESET SUCCESSFUL' : 'RESET MFA'}}</div>
          <div [ngClass]="{spinner: resettingMFA, 'icon-refresh': !resettingMFA, 'tap-to-download': !resettingMFA, 'icon-Icon_Check': mfaReset && !resettingMFA}"></div>
        </div>
      }
    </div>
  }
  @if (showQRCode) {
    <qrcode
      [errorCorrectionLevel]="'M'" [qrdata]="jwt"
      [width]="qrCodeSize" (click)="expandQRCode()"
      [ngClass]="{'qr-code-expandable': canExpand}"
    ></qrcode>
  }
  @if (!qrOnly) {
    <div class="qr-code-buttons">
      @if (hasJWT && type === 'identity') {
          <div (click)="deleteEnrollment()" class="delete-button">
            <div class="  tap-to-delete icon-Icon_Delete"></div>
            <div>DELETE ENROLLMENT</div>
            <div class="tap-to-delete icon-Icon_Delete"></div>
          </div>
      }
      @if (!jwtExpired && type === 'router') {
        <span class="info-text">OR</span>
      }
      @if (!jwtExpired && type === 'router') {
        <div (click)="identitiesSvc.downloadJWT(jwt, identity.name)" class="download-button">
          <div class="download-key"></div>
          <div>DOWNLOAD ENROLLMENT JWT</div>
          <div class="tap-to-download icon-download-jwt"></div>
        </div>
      }
      @if (showReenrollToken) {
        <div (click)="reenroll()" class="download-button" >
          <div class="download-key"></div>
          <div>REISSUE ENROLLMENT</div>
          <div class="tap-to-download icon-refresh"></div>
        </div>
      }
    </div>
  }
</div>
